import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { locale } = useRouter();
    const { t } = useLang('power_kits_48v_system');

    return (
        <div className={styles.TheComp}>
            <EfSection
                position="hover"
                theme="white"
                pc={
                    locale === 'de'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723626930510/pc_Keep%20the%20Peace_de.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1723100493410/pc_Keep%20the%20Peace.jpg'
                }
                pad={
                    locale === 'de'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723626930510/pc_Keep%20the%20Peace_de.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1723100493410/pc_Keep%20the%20Peace.jpg'
                }
                h5={
                    locale === 'de'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723626930514/m_Keep%20the%20Peace_de.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1723100791665/m_Keep%20the%20Peace.jpg'
                }
                label={t('E_label')}
                title={t('E_title')}
                desc={t('E_desc')}
            />
        </div>
    );
}
